// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../src/assets/iconfont/iconfont.js'
// 按需引入 ECharts 核心与常用图表组件，减小打包体积
import * as echarts from 'echarts/core';
import { PieChart, BarChart, LineChart } from 'echarts/charts';
import {
  TooltipComponent,
  LegendComponent,
  GridComponent,
  DatasetComponent,
  TitleComponent
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([
  PieChart,
  BarChart,
  LineChart,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  DatasetComponent,
  TitleComponent,
  CanvasRenderer
]);

// 全局挂载按需配置后的 echarts
Vue.prototype.$echarts = echarts

Vue.prototype.$deepClone = function deepClone(obj) {
  var target = {};
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      if (typeof obj[key] === 'object') {
        target[key] = deepClone(obj[key]);
      } else {
        target[key] = obj[key];
      }
    }
  }
  return target;
}

Vue.prototype.$add = function (a,b) {
  return (Math.round(a * 10000) + Math.round(b * 10000)) / 10000;
}

// 设置Vue的全局属性$token
Vue.prototype.$token = null;

// 加载阿里云验证码脚本，供注册页使用
const script = document.createElement('script');
script.src = 'https://o.alicdn.com/captcha-frontend/aliyunCaptcha/AliyunCaptcha.js';
script.async = true;
document.head.appendChild(script)

Vue.config.productionTip = false
Vue.use(ElementUI);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
